var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlukOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 9.89062L4.59083 11.7759L7.58306 9.90169",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 15.1197V11.7734",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88507 8.06232L2.06312 9.15436C1.65028 9.40154 1.3125 10.0213 1.3125 10.5305V12.6149C1.3125 13.1241 1.65028 13.7439 2.06312 13.9911L3.88507 15.0868C4.27402 15.3192 4.91205 15.3192 5.301 15.0868L7.12295 13.9911C7.53579 13.7439 7.87357 13.1241 7.87357 12.6149V10.5305C7.87357 10.0213 7.53579 9.40154 7.12295 9.15436L5.301 8.05863C4.90864 7.8262 4.27402 7.8262 3.88507 8.06232Z",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39062 9.89062L12.4033 11.7759L15.3956 9.90169",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 15.1197V11.7734",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6976 8.06232L9.87562 9.15436C9.46278 9.40154 9.125 10.0213 9.125 10.5305V12.6149C9.125 13.1241 9.46278 13.7439 9.87562 13.9911L11.6976 15.0868C12.0865 15.3192 12.7245 15.3192 13.1135 15.0868L14.9355 13.9911C15.3483 13.7439 15.6861 13.1241 15.6861 12.6149V10.5305C15.6861 10.0213 15.3483 9.40154 14.9355 9.15436L13.1135 8.05863C12.7211 7.8262 12.0865 7.8262 11.6976 8.06232Z",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26562 2.74414L8.27833 4.62938L11.2706 2.75521",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27344 7.97317V4.62695",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56475 0.915833L5.7428 2.00787C5.32996 2.25506 4.99219 2.87486 4.99219 3.38399V5.46845C4.99219 5.97758 5.32996 6.59739 5.7428 6.84457L7.56475 7.9403C7.95371 8.17273 8.59173 8.17273 8.98069 7.9403L10.8026 6.84457C11.2155 6.59739 11.5533 5.97758 11.5533 5.46845V3.38399C11.5533 2.87486 11.2155 2.25506 10.8026 2.00787L8.98069 0.912143C8.58832 0.679716 7.95371 0.679716 7.56475 0.915833Z",
    stroke: "#004EFF",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlukOrderIcon);
export default __webpack_public_path__ + "static/media/BlukOrderIcon.afff1979fd6a32d4b270f570f813fbc0.svg";
export { ForwardRef as ReactComponent };